"use client"

import {
  ModulesContent,
  ModulesHeader,
  modulesMockData,
  useModules,
} from "@/features/modules"

export default function ModulesPage() {
  const {
    searchQuery,
    setSearchQuery,
    allTags,
    selectedTags,
    handleTagChange,
    filteredModules,
  } = useModules(modulesMockData)

  return (
    <div className="flex h-full flex-col px-8">
      <div className="shrink-0 ">
        <ModulesHeader
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          allTags={allTags}
          selectedTags={selectedTags}
          handleTagChange={handleTagChange}
        />
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        <ModulesContent
          filteredModules={filteredModules}
        />
      </div>
    </div>
  )
}
